import { Tree } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import FileRepositoryNodeContent from './FileRepositoryNodeContent';

const { TreeNode } = Tree;

const FileRepositoryTree = (props) => (
  <Tree style={{ width: '100%' }}>

    {props.attachmentRepositories.map(attachmentRepository => (
      FileRepositoryNode({
        item: attachmentRepository,
        onAddSubcategory: props.onAddSubcategory,
        onSetIsEditing: props.onSetIsEditing,
        isEditing: props.isEditing,
        onDeleteCategory: props.onDeleteCategory,
        onDeleteAttachment: props.onDeleteAttachment,
        onAddFile: props.onAddFile,
        onAddLink: props.onAddLink,
      })))}
  </Tree>
);

function FileRepositoryNode({ item, isEditing, onAddSubcategory, onSetIsEditing, onDeleteCategory, onDeleteAttachment, onAddFile, onAddLink }) {
  return (
    <TreeNode
      title={
        <FileRepositoryNodeContent
          label={item.title}
          hasSubcategories={(item.children || []).length > 0}
          hasAttachments={(item.files || []).length > 0}
          item={item}
          onAddSubcategory={onAddSubcategory}
          onSetIsEditing={onSetIsEditing}
          isEditing={isEditing}
          onDeleteCategory={onDeleteCategory}
          onDeleteAttachment={onDeleteAttachment}
          onAddFile={onAddFile}
          onAddLink={onAddLink}
        />
      }
    >
      {item.children != null
        ? item.children?.map((item) =>
          FileRepositoryNode({
            item,
            isEditing,
            onAddSubcategory,
            onSetIsEditing,
            onDeleteCategory,
            onDeleteAttachment,
            onAddFile,
            onAddLink
          })
        )
        : null}
      {item.files?.map((file) => (
        <TreeNode
          title={
            <FileRepositoryNodeContent
              label={file.title}
              isAttachment={true}
              item={{ ...file, parent: item.id }}
              onAddSubcategory={onAddSubcategory}
              onSetIsEditing={onSetIsEditing}
              onDeleteCategory={onDeleteCategory}
              onDeleteAttachment={onDeleteAttachment}
              onAddFile={onAddFile}
              onAddLink={onAddLink}
            />
          }
        ></TreeNode>
      ))}
    </TreeNode>
  );
}

FileRepositoryTree.propTypes = {
  attachmentRepositories: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    files: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        fileUrl: PropTypes.string,
      })
    ),
    distributor: PropTypes.string,
    parent: PropTypes.string,
    children: PropTypes.arrayOf(PropTypes.shape(this)),
  })).isRequired,
  fetching: PropTypes.bool.isRequired,
  isEditing: PropTypes.bool.isRequired,
  onDeleteCategory: PropTypes.func.isRequired,
  onDeleteAttachment: PropTypes.func.isRequired,
  onAddFile: PropTypes.func.isRequired,
  onAddLink: PropTypes.func.isRequired,
  onAddSubcategory: PropTypes.func.isRequired,
  onSetIsEditing: PropTypes.func.isRequired,
};

export default FileRepositoryTree;
